import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

export interface FieldContext {
  controlName: string;
  minLength?: number;
  maxLength?: number;
  errorMsg?: string;
}

@Injectable({ providedIn: 'root' })
export class FormErrorService {
  shouldShowErrors(formGroup: FormGroup, field: FieldContext, isFormSubmitted: boolean): boolean {
    const control = this.getControl(formGroup, field.controlName);
    if (!control) {
      return false;
    }
    if (isFormSubmitted) {
      return control.invalid;
    }
    // Only show when the specific control has been touched (blurred)
    return control.invalid && control.touched === true;
  }

  getErrorMessages(formGroup: FormGroup, field: FieldContext): Array<{ key: string; params?: Record<string, unknown>; textOverride?: string }>{
    const control = this.getControl(formGroup, field.controlName);
    if (!control || !control.errors) {
      return [];
    }

    const messages: Array<{ key: string; params?: Record<string, unknown>; textOverride?: string }> = [];

    if (control.errors['required']) {
      if (field.errorMsg) {
        messages.push({ key: 'custom', textOverride: field.errorMsg });
      } else {
        messages.push({ key: 'formValidators.required' });
      }
    }

    if (control.hasError('pattern')) {
      messages.push({ key: 'formValidators.pattern' });
    }

    if (control.hasError('email')) {
      messages.push({ key: 'formValidators.email' });
    }

    if (control.hasError('minlength') && field.minLength) {
      messages.push({ key: 'formValidators.minLength', params: { value: field.minLength } });
    }

    if (control.hasError('maxlength') && field.maxLength) {
      messages.push({ key: 'formValidators.maxLength', params: { value: field.maxLength } });
    }

    if (control.hasError('invalidPostal')) {
      const countryValue = control.errors?.['countryValue'];
      messages.push({ key: 'formValidators.patternOfCodeCountry', params: { value: countryValue } });
    }

    if (control.hasError('ngbDate')) {
      messages.push({ key: 'formValidators.pattern' });
    }

    return messages;
  }

  private getControl(formGroup: FormGroup, controlName: string): AbstractControl<unknown, unknown> | null {
    return formGroup.get(controlName);
  }
}


